// Mutations
export const SET_COMMERCIAL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.commercial.data = payload
    state.commercial.lastUpdate = new Date()
  }
}
export const ADD_COMMERCIAL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.commercial.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.commercial.data.push(data)
      }
    })
  }
}
export const SET_COMMERCIAL_LOADING = (state, payload) => {
  state.commercial.loading = payload
}

export const SET_HISTORICAL_SENDERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.historicalSenders.data = payload
    state.historicalSenders.lastUpdate = new Date()
  }
}
export const ADD_HISTORICAL_SENDERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.historicalSenders.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.historicalSenders.data.push(data)
      }
    })
  }
}
export const SET_HISTORICAL_SENDERS_LOADING = (state, payload) => {
  state.historicalSenders.loading = payload
}

export const SET_HISTORICAL_CONVERSATIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.historicalConversations.data = payload
    state.historicalConversations.lastUpdate = new Date()
  }
}
export const ADD_HISTORICAL_CONVERSATIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.historicalConversations.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.historicalConversations.data.push(data)
      }
    })
  }
}
export const SET_HISTORICAL_CONVERSATIONS_LOADING = (state, payload) => {
  state.historicalConversations.loading = payload
}

export const SET_GOOGLE_STORE_TOKEN = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.googleStoreToken.data = payload
    state.googleStoreToken.lastUpdate = new Date()
  }
}
export const ADD_GOOGLE_STORE_TOKEN = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.googleStoreToken.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.googleStoreToken.data.push(data)
      }
    })
  }
}
export const SET_GOOGLE_STORE_TOKEN_LOADING = (state, payload) => {
  state.googleStoreToken.loading = payload
}

export const SET_HISTORICAL_CONVERSATION = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.historicalConversation.data = payload
    state.historicalConversation.lastUpdate = new Date()
  }
}
export const ADD_HISTORICAL_CONVERSATION = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.historicalConversation.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.historicalConversation.data.push(data)
      }
    })
  }
}
export const SET_HISTORICAL_CONVERSATION_LOADING = (state, payload) => {
  state.historicalConversation.loading = payload
}
export const SET_SEND_WHATSAPP_MESSAGE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.sendWhatsappMessage.data = payload
    state.sendWhatsappMessage.lastUpdate = new Date()
  }
}
export const ADD_SEND_WHATSAPP_MESSAGE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.sendWhatsappMessage.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.sendWhatsappMessage.data.push(data)
      }
    })
  }
}
export const SET_SEND_WHATSAPP_MESSAGE_LOADING = (state, payload) => {
  state.sendWhatsappMessage.loading = payload
}

export const SET_PERMISSIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.permissions.data = payload
    state.permissions.lastUpdate = new Date()
  }
}
export const ADD_PERMISSIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.permissions.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.permissions.data.push(data)
      }
    })
  }
}
export const SET_PERMISSIONS_LOADING = (state, payload) => {
  state.permissions.loading = payload
}

export const SET_STATUS_PERMISSIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.statusPermissions.data = payload
    state.statusPermissions.lastUpdate = new Date()
  }
}
export const ADD_STATUS_PERMISSIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.statusPermissions.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.statusPermissions.data.push(data)
      }
    })
  }
}
export const SET_STATUS_PERMISSIONS_LOADING = (state, payload) => {
  state.statusPermissions.loading = payload
}

export const SET_INTEGRATE_WITH_CALENDAR = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.integrateWithCalendar.data = payload
    state.integrateWithCalendar.lastUpdate = new Date()
  }
}
export const ADD_INTEGRATE_WITH_CALENDAR = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.integrateWithCalendar.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.integrateWithCalendar.data.push(data)
      }
    })
  }
}
export const SET_INTEGRATE_WITH_CALENDAR_LOADING = (state, payload) => {
  state.integrateWithCalendar.loading = payload
}

export const SET_STATUS_ALL_SDR = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.statusAllSdr.data = payload
    state.statusAllSdr.lastUpdate = new Date()
  }
}
export const ADD_STATUS_ALL_SDR = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.statusAllSdr.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.statusAllSdr.data.push(data)
      }
    })
  }
}
export const SET_STATUS_ALL_SDR_LOADING = (state, payload) => {
  state.statusAllSdr.loading = payload
}

export const SET_SETTINGS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.settings.data = payload
    state.settings.lastUpdate = new Date()
  }
}
export const ADD_SETTINGS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.settings.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.settings.data.push(data)
      }
    })
  }
}
export const SET_SETTINGS_LOADING = (state, payload) => {
  state.settings.loading = payload
}

export const SET_INTERNAL_VARIABLES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.internalVariables.data = payload
    state.internalVariables.lastUpdate = new Date()
  }
}
export const ADD_INTERNAL_VARIABLES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.internalVariables.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.internalVariables.data.push(data)
      }
    })
  }
}
export const SET_INTERNAL_VARIABLES_LOADING = (state, payload) => {
  state.internalVariables.loading = payload
}

export const SET_EXCEL_VARIABLES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.excelVariables.data = payload
    state.excelVariables.lastUpdate = new Date()
  }
}
export const ADD_EXCEL_VARIABLES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.excelVariables.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.excelVariables.data.push(data)
      }
    })
  }
}
export const SET_EXCEL_VARIABLES_LOADING = (state, payload) => {
  state.excelVariables.loading = payload
}

